import gql from "graphql-tag";

export const MY_NEWS_UPDATE_ITEM = gql`
  mutation updateMyNewsItem(
    $_id: String!
    $title: String
    $description: String
    $content: String
    $validFrom: Date
    $validTo: Date
    $priority: String
    $publish: Boolean
    $roleFilters: RoleFilterInput
  ) {
    updateMyNewsItem(
      _id: $_id
      title: $title
      description: $description
      content: $content
      validFrom: $validFrom
      validTo: $validTo
      priority: $priority
      publish: $publish
      roleFilters: $roleFilters
    ) {
      _id
    }
  }
`;
